var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.861C0 4.86259 4.92485 0 11 0C17.0752 0 22 4.86259 22 10.861V13.7998C20.1579 13.0719 18.1471 12.6711 16.0417 12.6711C7.18205 12.6711 0 19.7624 0 28.51V10.861Z",
    fill: "#E32142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 44.5098C24.8366 44.5098 32 37.3463 32 28.5098C32 19.6732 24.8366 12.5098 16 12.5098C7.16344 12.5098 0 19.6732 0 28.5098C0 37.3463 7.16344 44.5098 16 44.5098ZM16 36.7383C20.5445 36.7383 24.2286 33.0543 24.2286 28.5098C24.2286 23.9653 20.5445 20.2812 16 20.2812C11.4555 20.2812 7.77143 23.9653 7.77143 28.5098C7.77143 33.0543 11.4555 36.7383 16 36.7383Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.15409f7f99698a3a8c48105ac68b1d6e.svg";
export { ForwardRef as ReactComponent };